import { render, staticRenderFns } from "./Domain.vue?vue&type=template&id=06dcfa42&"
import script from "./Domain.vue?vue&type=script&lang=js&"
export * from "./Domain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports